module.exports = __webpack_public_path__ + "img/icon-round-warn.01c8c9b7.svg";